import type { Subscription } from '@/core/domain';
import type { SubscriptionRepository } from '../repositories/subscription-repository';

export class GetSubscriptionsByUserIdsUseCase {
  constructor(private readonly repository: SubscriptionRepository) {}

  execute(userIds: string[]): Promise<Map<string, Subscription | null>> {
    return this.repository.getByUserIds(userIds);
  }
}
